import { colors, variables } from "../../styles";
const { green, white, blue } = colors;
const { appToolbarMinHeight } = variables;

export default (theme) => ({
    appBar: {
        backgroundColor: theme.palette.common.white,
        zIndex: theme.zIndex.drawer + 1,
        "& .MuiToolbar-root": {
            padding: `0 ${theme.spacing(2)} 0 ${theme.spacing(4)}`
        }
    },
    content: {
        height: "100%",
        "& > div": {
            height: "inherit"
        }
    },
    main: {
        flexGrow: 1,
        height: `calc(100% - ${appToolbarMinHeight}px)`,
        marginTop: appToolbarMinHeight,
        padding: `0 ${theme.spacing(2)}`,
        overflow: "auto"
    },
    menuContainer: {
        marginRight: theme.spacing(1)
    },
    green: {
        color: green
    },
    root: {
        display: "flex",
        height: "100vh"
    },
    title: {
        flexGrow: 1,
        margin: `0 ${theme.spacing(2)}`
    }
});

export const activeMenuStyle = (isActive) => ({
    my: 2,
    color: isActive ? blue : "primary",
    display: "block",
    // fontWeight: isActive ? "bold" : "200",
    fontSize: "0.80rem",
    textTransform: "capitalize"
    // borderBottom: isActive ? `2px solid ${blue}` : "none"
});
